import { Box, Stack } from '@mui/material';
import { FC, useEffect, useState } from 'react';

import { USER_DASHBOARD_QUERY_KEYS } from '@/api/user-dashboard/queries';
import { Spinner, Typography } from '@/design-system';
import { useIsMobile } from '@/global-hooks/use-is-mobile';
import { KYC_COMPLETE_MESSAGE_TYPE } from '@/pages/kyc-complete';
import { colors } from '@/shared/design-system/colors';

import { queryClient } from './react-query-provider';

type ShuftiProKycProps = {
  verificationUrl: string;
};

export const ShuftiProKyc: FC<ShuftiProKycProps> = ({ verificationUrl }) => {
  const isMobile = useIsMobile();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (isMobile) {
      window.open(verificationUrl, '_blank');
    }
  }, [isMobile, verificationUrl]);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (
        event.origin === window.location.origin &&
        event.data?.type === KYC_COMPLETE_MESSAGE_TYPE
      ) {
        queryClient.invalidateQueries({ queryKey: [USER_DASHBOARD_QUERY_KEYS.userProfile] });
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <Box sx={{ position: 'relative', height: '470px', width: '100%' }}>
      {isLoading && (
        <Stack
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          alignItems="center"
          justifyContent="center"
          bgcolor="background.paper"
          gap="8px"
          zIndex={1}
        >
          <Spinner />
          <Typography color={colors.text.secondary}>Loading verification...</Typography>
        </Stack>
      )}
      <iframe
        src={verificationUrl}
        onLoad={() => setIsLoading(false)}
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          borderRadius: '8px',
        }}
        title="KYC Verification"
      />
    </Box>
  );
};
